// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__LeAoi","tab":"Tabs_tab__9ezKK","activeTab":"Tabs_activeTab__hputh"};